import {
  Hidden,
  Toolbar,
  Drawer,
  List,
  Typography,
} from "@mui/material";
import { Box, styled } from "@mui/system";

// icons & images
import { FaUserPlus } from "react-icons/fa";
import { BiSolidMoviePlay } from "react-icons/bi";
import {
  RiLoginCircleFill,
} from "react-icons/ri";

import { drawerWidth } from "./DashboardLayout";
import CustomListItem from "../components/Drawer/CustomListItem";
import IconLogo from "../IconLogo";
import FeedbackIcon from '@mui/icons-material/Feedback';

//import {ReactComponent as Logo2}from '../logo2.svg';
import SvgIcon from "@mui/material/SvgIcon";

const NavDrawerStyle = styled("nav")(({ theme }) => ({
  [theme.breakpoints.up("sm")]: {
    width: drawerWidth,
    flexShrink: 0,
  },
}));

const LogoStyle = styled(Typography)(({ theme }) => ({
  color: theme.palette.green.darker,
  margin: 0,
}));

const ListStyle = styled(List)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));


// links for the side nav
const links = [
  { id: "L0", path: "/video", icon: <BiSolidMoviePlay />, title: "Video" },
  { id: "L1", path: "/feedback", icon: <FeedbackIcon />, title: "Feedback" },
];

const SideDrawer = (props) => {
  const drawerContent = (
    <>
      <Toolbar sx={{ display: 'flex', justifyContent: 'center' }}>
        <SvgIcon style={{ width: '100px', height: 'auto' }}>
          <IconLogo />
        </SvgIcon>
      </Toolbar>

      {/* List of links */}
      <ListStyle>
        {links.map((el) => (
          <CustomListItem
            key={el.id}
            path={el.path}
            icon={el.icon}
            title={el.title}
            onClick={props.onClose}
          />
        ))}
      </ListStyle>
    </>
  );

  return (
    <NavDrawerStyle aria-label="Navigation Panel">
      {/* Hidden 01 for sm size */}
      <Hidden smUp implementation="css">
        <Drawer
          container={props.container}
          variant="temporary"
          anchor="top"
          open={props.toggleMenu}
          onClose={props.onClose}
          classes={{ paper: props.drawerPaper }}
          ModalProps={{ keepMounted: true }}
        >
          {/* Drawer Component */}
          {drawerContent}
        </Drawer>
      </Hidden>

      {/* Hidden 02 for big size*/}
      <Hidden xsDown implementation="css">
        <Drawer variant="permanent" open classes={{ paper: props.drawerPaper }}>
          {drawerContent}
        </Drawer>
      </Hidden>
    </NavDrawerStyle>
  );
};

export default SideDrawer;
